<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="order-new-wrapper card">
            <form action="" @submit.prevent="openPreview" class="row">
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="product_type" class="form-label">نوع محصول</label>
                            <select class="form-control" id="product_type" v-model="product_type" @change="onProductTypeChange">
                                <option value="gold">طلا</option>
                                <option value="silver">نقره</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="product_search" class="form-label">انتخاب محصول</label>
                            <div class="product-search-bar">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="product_search"
                                    v-model="searchQuery"
                                    :disabled="!product_type || searchLoading"
                                    placeholder="کد یکتا، نام یا sku"
                                    enterkeyhint="search"
                                    @keydown.enter.prevent="runSearch(1)"
                                >
                                <button
                                    type="button"
                                    class="btn btn-primary product-search-btn"
                                    :disabled="!product_type || searchLoading"
                                    @click="runSearch(1)"
                                >
                                    <span v-if="searchLoading">...</span>
                                    <span v-else>جستجو</span>
                                </button>
                            </div>
                            <small class="text-muted d-block mt-1">
                                Enter یا دکمه جستجو — فقط محصولات {{ product_type === 'silver' ? 'نقره' : 'طلا' }} — هر صفحه ۲۰ نتیجه.
                            </small>

                            <div v-if="product" class="selected-product alert alert-success py-2 mt-2 mb-0 d-flex justify-content-between align-items-center">
                                <span>
                                    انتخاب‌شده: <strong>{{ product.name }}</strong>
                                    <span class="text-muted">#{{ product.id }}</span>
                                    <span class="text-muted" v-if="product.weight"> — وزن: {{ product.weight }} گرم</span>
                                </span>
                                <button type="button" class="btn btn-sm btn-light" @click="clearProduct">حذف</button>
                            </div>

                            <div v-if="searchLoading" class="text-center py-3 text-muted">در حال جستجو...</div>

                            <div v-else-if="hasSearched" class="product-search-results mt-2 border rounded">
                                <div v-if="!options.length" class="p-3 text-muted text-center">نتیجه‌ای پیدا نشد.</div>
                                <button
                                    v-for="option in options"
                                    :key="option.id"
                                    type="button"
                                    class="product-search-row btn btn-light w-100 text-start rounded-0 border-0 border-bottom"
                                    :class="{ active: product && product.id === option.id }"
                                    @click="selectProduct(option)"
                                >
                                    <div class="search-res-option">
                                        <img :src="option.image" alt="">
                                        <div class="name">
                                            {{ option.name }}
                                            <small class="text-muted d-block" v-if="option.weight">وزن: {{ option.weight }} گرم</small>
                                        </div>
                                        <div class="id">#{{ option.id }}</div>
                                    </div>
                                </button>
                                <div v-if="searchTotalPages > 1" class="d-flex justify-content-between align-items-center p-2 bg-light">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="searchPage <= 1 || searchLoading" @click="runSearch(searchPage - 1)">قبلی</button>
                                    <small class="text-muted">صفحه {{ searchPage }} از {{ searchTotalPages }} ({{ searchTotal }} نتیجه)</small>
                                    <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="searchPage >= searchTotalPages || searchLoading" @click="runSearch(searchPage + 1)">بعدی</button>
                                </div>
                                <div v-else-if="searchTotal > 0" class="p-2 bg-light text-center">
                                    <small class="text-muted">{{ searchTotal }} نتیجه</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" v-if="product_type === 'gold'">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="gold_price" class="form-label">مظنه روز طلا (تومان)</label>
                            <input type="number" class="form-control" id="gold_price" v-model="gold_price">
                            <small class="text-muted" v-if="goldPriceRange">
                                مظنه ثبت شده در سایت: {{ goldPriceRange.gold_price.toLocaleString() }} تومان —
                                بازه مجاز: {{ goldPriceRange.min_gold_price.toLocaleString() }} تا
                                {{ goldPriceRange.max_gold_price.toLocaleString() }} تومان
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" v-if="product_type === 'silver' && isSilverDynamic">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="silver_price" class="form-label">مظنه روز نقره (تومان)</label>
                            <input type="number" class="form-control" id="silver_price" v-model="silver_price">
                            <small class="text-muted" v-if="silverPriceRange">
                                مظنه ثبت شده در سایت: {{ silverPriceRange.silver_price.toLocaleString() }} تومان —
                                بازه مجاز: {{ silverPriceRange.min_silver_price.toLocaleString() }} تا
                                {{ silverPriceRange.max_silver_price.toLocaleString() }} تومان
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" v-if="product_type === 'silver' && !isSilverDynamic">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="unit_price" class="form-label">قیمت سفارش (تومان)</label>
                            <input type="number" class="form-control" id="unit_price" v-model="unit_price" min="1">
                            <small class="text-muted">فقط روی همین سفارش اعمال می‌شود؛ قیمت محصول در سایت عوض نمی‌شود.</small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="payment_method" class="form-label">روش پرداخت</label>
                            <select class="form-control" id="payment_method" v-model="payment_method">
                                <option value="bazar_pos">دستگاه پوز</option>
                                <option value="bazar_cash">پرداخت نقدی</option>
                                <option value="bazar_card">کارت به کارت</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="fname" class="form-label">نام مشتری</label>
                            <input type="text" class="form-control" id="fname" v-model="fname">
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="lname" class="form-label">نام خانوادگی مشتری</label>
                            <input type="text" class="form-control" id="lname" v-model="lname">
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="order-new-item">
                            <label for="phone" class="form-label">شماره تماس مشتری</label>
                            <input type="text" class="form-control" id="phone" v-model="phone">
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="hstack gap-2 justify-content-end">
                        <button type="submit" class="btn btn-primary" :disabled="previewLoading"> مشاهده پیش‌فاکتور</button>
                    </div>
                </div>
            </form>
        </div>

        <!-- پیش‌فاکتور (pro-forma) modal -->
        <div class="modal fade show d-block" tabindex="-1" v-if="showPreview" style="background: rgba(0,0,0,.5)">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title">پیش‌فاکتور</h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="showPreview = false"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="previewLoading" class="text-center py-4">
                            <b-spinner variant="warning"></b-spinner>
                            <div class="mt-2 text-muted">در حال محاسبه قیمت‌ها...</div>
                        </div>
                        <template v-else-if="previewData">
                            <div class="table-responsive">
                                <table class="table align-middle mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>محصول</th>
                                            <th>وزن</th>
                                            <th>تعداد</th>
                                            <th>قیمت واحد</th>
                                            <th>جمع</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in previewData.items" :key="i">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.weight ? (item.weight + ' گرم') : '—' }}</td>
                                            <td>{{ item.quantity }}</td>
                                            <td v-html="item.unit_price_html"></td>
                                            <td v-html="item.line_total_html"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-end align-items-center gap-2 mt-3 fs-15 fw-semibold">
                                <span>مبلغ کل:</span>
                                <span v-html="previewData.total_html"></span>
                            </div>
                            <small class="text-muted d-block mt-2">این یک پیش‌فاکتور است و سفارش هنوز ثبت نشده. برای ثبت، «تایید و ثبت نهایی» را بزنید.</small>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" @click="showPreview = false">بازگشت و ویرایش</button>
                        <button type="button" class="btn btn-success" :disabled="submitting || previewLoading" @click="confirmSubmit">
                            <b-spinner small v-if="submitting"></b-spinner>
                            تایید و ثبت نهایی
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import UserService from "@/services/user.service";

export default {
    name: "order-new.vue",
    page: {
        title: "سفارش جدید",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "سفارش جدید",
            options: [],
            product: null,
            product_type: 'gold',
            payment_method: 'bazar_pos',
            gold_price: '',
            silver_price: '',
            unit_price: '',
            goldPriceRange: null,
            silverPriceRange: null,
            fname: '',
            lname: '',
            phone: '',
            showPreview: false,
            previewLoading: false,
            previewData: null,
            submitting: false,
            searchQuery: '',
            searchLoading: false,
            hasSearched: false,
            searchPage: 1,
            searchTotal: 0,
            searchTotalPages: 0,
            searchPerPage: 20,
        }
    },
    mounted() {
        this.getGoldPrice();
        this.getSilverPrice();
    },
    computed: {
        isSilverDynamic() {
            if (this.product_type !== 'silver' || !this.product) return false;
            return this.product.price_type === 'dynamic';
        },
    },
    methods: {
        getGoldPrice() {
            return UserService.BranchGoldPrice()
                .then((response) => {
                    this.goldPriceRange = response.data;
                    this.gold_price = response.data.gold_price;
                });
        },
        getSilverPrice() {
            return UserService.BranchSilverPrice()
                .then((response) => {
                    this.silverPriceRange = response.data;
                    this.silver_price = response.data.silver_price;
                })
                .catch(() => {
                    this.silverPriceRange = null;
                });
        },
        onProductTypeChange() {
            this.clearProduct();
            this.options = [];
            this.unit_price = '';
            this.searchQuery = '';
            this.hasSearched = false;
            this.searchPage = 1;
            this.searchTotal = 0;
            this.searchTotalPages = 0;
        },
        selectProduct(option) {
            this.product = option;
            if (this.product_type === 'silver' && option.price_type !== 'dynamic' && option.price != null && option.price !== '') {
                this.unit_price = option.price;
            }
        },
        clearProduct() {
            this.product = null;
            if (this.product_type === 'silver') {
                this.unit_price = '';
            }
        },
        validate() {
            let has_error = false;
            if (!this.product_type) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'نوع محصول انتخاب نشده است.', type: 'error'});
            }
            if (!this.product || !this.product.id) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'محصولی انتخاب نشده است.', type: 'error'});
            }
            if (this.product_type === 'gold' && !this.gold_price) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'مظنه روز وارد نشده است.', type: 'error'});
            }
            if (this.product_type === 'silver' && this.isSilverDynamic && !this.silver_price) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'مظنه نقره وارد نشده است.', type: 'error'});
            }
            if (this.product_type === 'silver' && !this.isSilverDynamic && !(parseInt(this.unit_price, 10) > 0)) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'قیمت سفارش نقره وارد نشده است.', type: 'error'});
            }
            if (!this.payment_method.length) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'روش پرداخت انتخاب نشده است.', type: 'error'});
            }
            if (!this.fname.length) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'نام مشتری وارد نشده است.', type: 'error'});
            }
            if (!this.lname.length) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'نام خانوادگی مشتری وارد نشده است.', type: 'error'});
            }
            if (!this.phone.length) {
                has_error = true;
                this.$notify({title: 'خطا', text: 'شماره مشتری وارد نشده است.', type: 'error'});
            }
            return !has_error;
        },
        buildPricingPayload() {
            const payload = {
                products: [{id: this.product.id}],
                product_type: this.product_type,
            };
            if (this.product_type === 'gold') {
                payload.gold_price = this.gold_price;
            } else if (this.isSilverDynamic) {
                payload.silver_price = this.silver_price;
            } else {
                payload.unit_price = this.unit_price;
            }
            return payload;
        },
        openPreview() {
            if (!this.validate()) return;

            this.previewData = null;
            this.previewLoading = true;
            this.showPreview = true;

            return UserService.BranchOrderPreview(this.buildPricingPayload())
                .then((response) => {
                    this.previewData = response.data;
                }, (error) => {
                    this.showPreview = false;
                    this.$notify({
                        title: "خطا",
                        text: error.response?.data?.message || error.message,
                        type: 'error',
                    });
                })
                .then(() => {
                    this.previewLoading = false;
                });
        },
        confirmSubmit() {
            if (this.submitting) return;
            this.submitting = true;

            const payload = {
                ...this.buildPricingPayload(),
                products: [this.product.id],
                fname: this.fname,
                lname: this.lname,
                phone: this.phone,
                payment_method: this.payment_method,
            };

            return UserService.BranchOrderSubmit(payload)
                .then((response) => {
                    this.showPreview = false;
                    this.$notify({
                        title: 'سفارش با موفقیت ثبت شد.',
                        text: response.data?.message ? ('شماره سفارش: ' + response.data.message) : '',
                        type: 'success',
                    });
                    this.product = null;
                    this.previewData = null;
                    this.$router.push({name: 'orders'});
                }, (error) => {
                    this.$notify({
                        title: "خطا",
                        text: error.response?.data?.message || error.message,
                        type: 'error',
                    });
                })
                .then(() => {
                    this.submitting = false;
                });
        },
        runSearch(page = 1) {
            const search = this.toEnglishDigits((this.searchQuery || '').trim());
            if (!search) {
                this.$notify({title: 'خطا', text: 'برای جستجو متن وارد کنید.', type: 'error'});
                return;
            }
            if (!this.product_type) {
                this.$notify({title: 'خطا', text: 'ابتدا نوع محصول را انتخاب کنید.', type: 'error'});
                return;
            }

            this.searchLoading = true;
            this.searchPage = page;
            this.hasSearched = true;

            return UserService.BranchProductSearch({
                key: search,
                material: this.product_type,
                page: page,
                per_page: this.searchPerPage,
            })
                .then((response) => {
                    const data = response.data || {};
                    this.options = Array.isArray(data) ? data : (data.items || []);
                    this.searchTotal = data.total || this.options.length;
                    this.searchPage = data.page || page;
                    this.searchTotalPages = data.total_pages || 1;
                }, (error) => {
                    this.options = [];
                    this.searchTotal = 0;
                    this.searchTotalPages = 0;
                    this.$notify({
                        title: "خطا",
                        text: error.response?.data?.message || error.message,
                        type: 'error',
                    });
                })
                .then(() => {
                    this.searchLoading = false;
                });
        },
        toEnglishDigits(value) {
            return String(value)
                .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
                .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
        }
    },
    components: {
        Layout,
        PageHeader,
    }
}
</script>

<style scoped>
.product-search-bar {
    display: flex;
    gap: 8px;
    align-items: stretch;
}
.product-search-bar .form-control {
    flex: 1;
    min-width: 0;
}
.product-search-btn {
    flex-shrink: 0;
    min-width: 96px;
    min-height: 44px;
    white-space: nowrap;
}
@media (max-width: 576px) {
    .product-search-bar {
        flex-direction: column;
    }
    .product-search-btn {
        width: 100%;
        min-height: 48px;
    }
}
.product-search-results {
    max-height: 360px;
    overflow-y: auto;
}
.product-search-row.active {
    background: #eef6ff !important;
}
.search-res-option {
    display: flex;
    align-items: center;
    gap: 10px;
}
.search-res-option img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 4px;
}
.search-res-option .name {
    flex: 1;
}
.search-res-option .id {
    color: #888;
    font-size: 12px;
}
</style>
